function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.572 7.737L16.715.75h-1.456L9.923 6.816 5.663.75H.75l6.442 9.173L.75 17.25h1.456l5.632-6.407 4.498 6.407h4.914l-6.678-9.513zm-1.995 2.267l-.653-.914L2.73 1.824h2.236L9.16 7.69l.65.914 5.45 7.625h-2.236l-4.446-6.225z",
  fill: "currentColor"
}));